import { Spinner, SpinnerProps } from "@fluentui/react-components";

export default function AppLoader(props: SpinnerProps) {
  return <Spinner {...props} />;
}
